import { render } from "./ProjectNavigationButtons.vue?vue&type=template&id=33af6a16"
import script from "./ProjectNavigationButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectNavigationButtons.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Admin/Project/ProjectNavigationButtons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33af6a16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33af6a16', __exports__)) {
    api.reload('33af6a16', __exports__)
  }
  
  module.hot.accept("./ProjectNavigationButtons.vue?vue&type=template&id=33af6a16", () => {
    api.rerender('33af6a16', render)
  })

}


export default __exports__